// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__uPMf3","box":"tooltip_box__F9Ae7","iconWrapper":"tooltip_iconWrapper__+eZGQ","badge":"tooltip_badge__U3PWN"};